import CloseIcon from '@mui/icons-material/Close';
import {Box, Drawer as MuiDrawer} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {makeStyles} from '@mui/styles';
import React, {useEffect, useState} from 'react';
import QRCode from 'react-qr-code';
import {useSelector} from 'react-redux';
import config from 'src/config';
import layoutSelectors from 'src/modules/layout/layoutSelectors';
import {magicFlexBox} from 'src/theme/schemes/CustomTheme';

const useStyles = makeStyles((theme: any) => ({
  toolbarOffset: theme.mixins.toolbar,
}));

export default function Drawer(props) {
  let {visible, setVisible} = props;
  if (visible === undefined && setVisible === undefined) {
    [visible, setVisible] = useState(false);
  }
  const [drawerId, setDrawerId] = useState(props.drawerId);

  const layout = useSelector(layoutSelectors.selectRaw);

  const classes = useStyles();

  useEffect(() => {
    if (drawerId === layout.drawerId) {
      setVisible(layout.drawerVisible);
    }
  }, [layout.drawerChanged]);

  useEffect(() => {
    setDrawerId(props.drawerId);
  }, [props.drawerId]);

  useEffect(() => {
    if (props.open) {
      setVisible(true);
    }
  }, [props.open]);

  return (
    <MuiDrawer
      key={drawerId + (props.keyId || '')}
      onClick={($event) => props.stopPropagation && $event.stopPropagation()}
      anchor={window.innerWidth > 768 ? 'right' : 'top'}
      open={visible}
      ModalProps={{
        ...props.ModalProps,
        sx: {
          ...(props.modalZIndex != null ? {zIndex: props.modalZIndex} : null),
          ...props.ModalProps?.sx,
        },
      }}
      sx={props.sx}
      onClose={(ev, reason) => {
        if (props.promptBeforeExit && reason === 'backdropClick') {
          if (!window.confirm(props.promptBeforeExit)) {
            return;
          }
        } else {
          if (props.preventBackdrop && reason === 'backdropClick') return;
        }
        setVisible(!visible);
        props.onClose && props.onClose();
      }}>
      {props.qrLink && (
        <div style={{position: 'relative'}}>
          <div
            style={{
              position: 'absolute',
              top: 132,
              left: -(140 + 8 * 2),
              backgroundColor: 'white',
              padding: '12px',
              paddingBottom: '8px',
              borderRadius: '8px',
            }}>
            <QRCode value={`${config.frontendUrl.protocol}://${config.frontendUrl.host}/${props.qrLink}`} size={140} />
          </div>
        </div>
      )}
      <Box
        sx={{
          paddingLeft: 2,
          paddingBottom: '15px',
          height: '100vh',
          maxHeight: '100vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          width: window.innerWidth > 768 ? props.width || null : null,
        }}>
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
          }}
          className={classes.toolbarOffset}></div>
        <Box style={{width: '100%', textAlign: 'end', marginTop: 2, marginBottom: -7, paddingRight: 15}}>
          <IconButton
            onClick={() => {
              setVisible(!visible);
              props.onClose && props.onClose();
            }}
            size="small"
            aria-label="close"
            style={{
              borderRadius: '50%',
              border: '1px solid black',
            }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box style={{...magicFlexBox, paddingRight: 15} as any}>{props.component}</Box>
      </Box>
    </MuiDrawer>
  );
}
